import React from 'react';
import ButtonSolid from 'components/Buttons/ButtonSolid';
import {RiseInterstitialProps} from 'screens/InsomniaSurvey/components/RiseInterstitialTemplate/RiseInterstitialBase';
import {surveyInstance} from 'screens/InsomniaSurvey/InsomniaSurvey';
import Analytics from 'utils/Analytics';
import styles from './RiseAppHandoffInterstitial.module.css';

const RISE_APP_STORE_URL = 'https://apps.apple.com/us/app/rise-sleep-tracker/id1453884781';

const RiseAppHandoffInterstitial: React.FC<RiseInterstitialProps> = () => {
  const handleContinue = () => {
    Analytics.track('Clinic Web Intake Continued To App Clicked', {
      source_screen: 'clinic_capacity_app_handoff',
      destination_url: RISE_APP_STORE_URL,
      insurance_state: surveyInstance.getValue('insurance_state'),
      insurance_coverage: surveyInstance.getValue('insurance_coverage'),
      clinic_waitlist_joined: Boolean(surveyInstance.getValue('clinic_waitlist_email')),
      clinic_booking_paused: surveyInstance.getValue('clinic_booking_paused'),
    });
    window.location.assign(RISE_APP_STORE_URL);
  };

  return (
    <div className={styles.container}>
      <div className={styles.heroPanel}>
        <div className={styles.iconWrap}>RISE</div>
        <div className={styles.energyLine}>
          <span />
          <span />
          <span />
        </div>
        <h1 className={styles.headerText}>Keep working on your sleep with RISE</h1>
        <div className={styles.bodyText}>
          <p>
            If you're still feeling tired or exhausted, the RISE app can help you understand your sleep debt, plan your
            energy peaks, and build better sleep habits until availability opens up.
          </p>
        </div>
        <div className={styles.featureRow}>
          <div>Sleep debt</div>
          <div>Energy peaks</div>
          <div>Habits</div>
        </div>
      </div>
      <ButtonSolid title="Continue to the RISE app" variant="purple" onClick={handleContinue} />
    </div>
  );
};

export default RiseAppHandoffInterstitial;
